import { motion } from "framer-motion";
import { Target, Users, Trophy, Flame } from "lucide-react";

const pillars = [
  { icon: Target, title: "Precisión", desc: "Sistemas estratégicos para operar con disciplina militar." },
  { icon: Users, title: "Comunidad", desc: "Comunidad 24/7 que respalda tu avance como trader." },
  { icon: Trophy, title: "Mérito", desc: "Un sistema de rangos donde cada logro se convierte en recompensa." },
  { icon: Flame, title: "Rentabilidad", desc: "Estrategias probadas por ciclo de mercado y bitácora de mejora." },
];

export default function Academia() {
  return (
    <section
      id="academia"
      className="relative py-24 md:py-32 bg-black overflow-hidden"
      data-testid="academia-section"
    >
      <div className="absolute inset-0 opacity-60 grid-bg pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
              / Academia
            </span>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase leading-none tracking-tight">
              Opera como un{" "}
              <span className="italic text-[#BEDD7D]">estratega</span>, no como un apostador.
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="space-y-6"
          >
            <p className="text-white/80 font-body text-lg leading-relaxed">
              Somos una plataforma de transformación personal, diseñada con precisión
              estratégica para formar operadores que no solo entienden los mercados, sino que se
              convierten en <span className="text-[#BEDD7D]">líderes disciplinados, resilientes y rentables</span>.
            </p>
            <p className="text-white/60 font-body leading-relaxed">
              Conviértete en un profesional del trading, avanzando con nuestra dinámica de
              rangos, generando ingresos por estudiar en nuestro sistema militar de formación.
            </p>
          </motion.div>
        </div>

        {/* Pillars */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#3E4D36]/30 border border-[#3E4D36]/40 rounded-2xl overflow-hidden">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-black hover:bg-[#1A2E1A]/60 transition-colors p-8 md:p-10 group"
              data-testid={`pillar-${p.title.toLowerCase()}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#1A2E1A] border border-[#BEDD7D]/30 flex items-center justify-center group-hover:border-[#BEDD7D] transition-colors">
                <p.icon className="w-5 h-5 text-[#BEDD7D]" />
              </div>
              <h3 className="mt-5 font-display font-bold text-xl uppercase tracking-wide">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-white/60 font-body leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
